module.exports = __webpack_public_path__ + "img/電気回路_3_2_4.2aa3b982.png";